import React, {useState} from "react";
import {Prompt} from "react-router-dom";
import {Button, CircularProgress, Typography} from "@mui/material";
import {TemplateForm} from "../forms";
import {templateService} from "../../services";
import {forms} from "@atttomyx/shared-utils";
import {verbiage} from "@atttomyx/shared-constants";

const freshData = () => {
    return {
        name: null,
        content: null,
        order: 0,
        valid: false,
    }
};

const AddTemplatePage = (props) => {
    const { snackbar, submissionMergeFields, onSave } = props;
    const [ data, setData ] = useState(freshData());
    const [ saving, setSaving ] = useState(false);

    const resetForm = () => {
        setData(freshData());
    };

    const submitForm = () => {
        setSaving(true);

        const template = {
            name: data.name,
            content: data.content,
            order: data.order,
        };

        const success = (template) => {
            resetForm();
            setSaving(false);

            snackbar.setSuccess("Template saved");
            onSave(template);
        };

        const failure = (err) => {
            setSaving(false);

            snackbar.setError(err);
        };

        templateService.createTemplate(template, success, failure);
    }

    const valid = data.valid;
    const modified = forms.differ(freshData(), data);

    return saving ?
        <div className="add-template-page">
            <CircularProgress size="80px"/>
        </div> :
        <div className="add-template-page">
            <Typography variant="h5" paragraph={true}>
                Add Template
            </Typography>
            <TemplateForm
                submissionMergeFields={submissionMergeFields}
                data={data}
                onChange={setData}
            />
            <div className="actions">
                <Button color="secondary" variant="text"
                        disabled={!modified}
                        onClick={resetForm}>
                    Undo
                </Button>
                <Button color="primary" size="large"
                        disabled={!valid || !modified}
                        onClick={submitForm}>
                    Save
                </Button>
            </div>
            <Prompt when={modified} message={verbiage.UNSAVED_CHANGES}/>
        </div>
}

export default AddTemplatePage;
